import { useEffect, useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { mockIntegrationData } from '../../../../api/integrationsMockData';
import { useListIntegrationSpecs, useUserRole } from '../../../../api/query';
import { DashboardView } from '../../../../pages';
import { useIntegrationsDashboardShallowStore } from '../../../../store';

const DEFAULT_INTEGRATIONS_DATA = { integrationSpecs: [] };

const Dashboard = () => {
  const { authenticatedUser } = Route.useLoaderData();
  const {
    data: integrationSpecsData,
    isLoading: isIntegrationsLoading,
    isFetching: isIntegrationsFetching,
    isError: isIntegrationsError,
    isLoadingError: isIntegrationsLoadingError,
  } = useListIntegrationSpecs();
  const {
    data: userData,
    isLoading: isUserLoading,
    isFetching: isUserFetching,
    isError: isUserError,
    isLoadingError: isUserLoadingError,
  } = useUserRole(authenticatedUser?.username);
  const { setIsUserLoggingIn } = useIntegrationsDashboardShallowStore('setIsUserLoggingIn');

  const { integrationSpecs } = integrationSpecsData ?? DEFAULT_INTEGRATIONS_DATA;
  const userRole = userData?.data?.role;

  useEffect(() => {
    setIsUserLoggingIn(false);
  }, []);

  //TODO: Remove this useMemo after api response return multiple data
  const integrationsData = useMemo(() => [...(integrationSpecs ?? []), ...mockIntegrationData], [integrationSpecs]);

  return (
    <DashboardView
      authenticatedUser={authenticatedUser}
      integrations={integrationsData}
      userRole={userRole}
      isLoading={isIntegrationsLoading || isIntegrationsFetching || isUserLoading || isUserFetching}
      isError={isIntegrationsError || isIntegrationsLoadingError || isUserError || isUserLoadingError}
    />
  );
};

export const Route = createFileRoute('/_auth/dashboard/')({
  component: Dashboard,
  loader: ({ context }) => {
    return { authenticatedUser: context.user };
  },
});
